<template>
    <div>
        <buttonlist @help="help" ref="SetBtn"></buttonlist>
        <div style="width:100%">
            <el-divider content-position="left">{{$t('getapi[6384]')}}</el-divider>
            <div style="display: flex">
                <el-button type="primary" size="mini" @click.native="calculate(1)">{{$t('getapi[2530]')}}</el-button>
                <el-button type="primary" size="mini" @click="exp" :disabled="url == ''">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-divider content-position="left">{{$t('getapi[6385]')}}</el-divider>
            <div style="display: flex">
                <el-button type="primary" size="mini" @click.native="downloadModel">{{$t('getapi[6111]')}}</el-button>
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadurl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        style="margin-left: 8px"
                >
                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[436]')}}</el-button>
                </el-upload>
                <el-button type="primary" size="mini" @click.native="calculate(2)" style="margin-left: 8px">{{$t('getapi[2530]')}}</el-button>
                <el-button type="primary" size="mini" @click="exp" :disabled="url == ''">{{ $t('getapi[922]') }}</el-button>
            </div>
            <div id="xpane-0">
                <vxe-table
                    :data="dataSet"
                    :highlight-current-row="true"
                    :height="tableHeight"
                    :loading="loading"
                    resizable
                    show-overflow="tooltip"
                    :auto-resize="true"
                    header-row-class-name="headerclass"
                    border
                    size="mini"
                    style="width: 100%; margin-top:5px"
                    ref="singleTable"
            >
                <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="150"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="150"></vxe-table-column>
                <vxe-table-column field="qty" :title="$t('getapi[6386]')" align="right" width="150">
                    <template slot-scope="scope">
                        {{scope.row.qty | thousandth}}
                    </template>
                </vxe-table-column>
            </vxe-table>
            </div>
        </div>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_urgentso',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                file: null,
                partArr: [],
                dataSet: [],
                scrollTop:0,
                url:'',
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let token = that.userData.token;
            that.uploadurl = Common.Url + '/Pro/SO/UrgentSoUpFile?token=' + token;
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6417]"),this.$t("getapi[25]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            downloadModel(){
                let that = this
                let param={
                    url:'/Pro/SO/DownloadUrgentSoTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(document.getElementsByClassName("el-upload__input"))
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.partArr = []
                    let arr = res.DataContent.dt
                    for(let i =0;i<arr.length;i++){
                        that.partArr = [...that.partArr,{
                            part_code: arr[i]['物料编码']
                        }]
                    }
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            // 计算
            calculate(type){
                let that = this
                if(type == 1){
                    that.loading = true
                    that.$http.urlpost('/Pro/SO/GetUrgentSoList', '', function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.dataSet = res.DataContent.DataList
                            that.url = res.DataContent.URL
                        }
                        that.loading = false
                    });
                } else {
                    let parm = {
                        Lists: that.partArr
                    }
                    that.loading = true
                    that.$http.urlpost('/Pro/SO/GetUrgentSoMethodTwo', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.dataSet = res.DataContent.DataList
                            that.url = res.DataContent.URL
                        }
                        that.loading = false
                    });
                }
            },
            exp(){
                let that = this
                let hrefurl = Common.Url + that.url;
                window.open(hrefurl);
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
